const absoluteUrl = (href) => {
  if (href.startsWith('http://') || href.startsWith('https://')) {
    return href;
  }
  return `https://${href}`;
};

const setLink = (editor) => {
  const previousUrl = editor.getAttributes('link').href;
  const url = window.prompt('URL', previousUrl);

  if (url === null) {
    return;
  }

  const trimmedUrl = url.trim();
  if (trimmedUrl.length === 0) {
    editor.chain().focus().extendMarkRange('link').unsetLink().run();
  } else {
    const href = absoluteUrl(trimmedUrl);
    editor.chain().focus().extendMarkRange('link').setLink({ href }).run();
  }
};

const visitLink = (editor) => {
  const { href } = editor.getAttributes('link');
  href && window.open(absoluteUrl(href), '_blank');
};

export default {
  'link:set': setLink,
  'link:visit': visitLink,
};
